import n from "./ghl-ui.es1506.js";
import s from "./ghl-ui.es1466.js";
function l(r) {
  s(1, arguments);
  var e = n(r), a = e.getFullYear(), o = e.getMonth(), t = /* @__PURE__ */ new Date(0);
  return t.setFullYear(a, o + 1, 0), t.setHours(0, 0, 0, 0), t.getDate();
}
export {
  l as default
};
